<template>
  <div class="upload" v-if="this.action !== ''">
    <input
      ref="input"
      type="file"
      :multiple="multiple"
      class="upload-input"
      :name="name"
      :accept="accept === '*' ? '' : accept"
      :webkitdirectory="webkitdirectory"
      @change="handleChange"/>
    <button
      class="upload-button"
      :class="{'upload-disabled': this.disabled}"
      ref="uploadBtn"
      type="button"
      @click="handleClick"
      :disabled="disabled"
      :style="btnStyle">
      {{ text }}
    </button>
  </div>
</template>

<script>
import ajax from './upload-ajax.js'
import UploadList from '../upload_list/upload-list'
import VUEUpLoad from './upload-config'
import Validate from './upload-validate'

function noop () {

}

export default {
  name: 'upload',
  components: {

  },
  created () {
    // 组件创建时检查upload_url
    if (!this.action) throw new Error('upload_url is not defined!')
  },
  props: {
    webkitdirectory: {
      type: Boolean,
      default: false
    },
    serial: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: 'Upload'
    },
    btnStyle: {
      type: Object
    },
    // 提交地址 等同于upload_url
    action: {
      type: String,
      required: true
    },
    // 上传请求头部
    headers: {
      type: Object,
      default () {
        return {}
      }
    },
    // 上传附带参数 等同于post_params
    data: {
      type: Object
    },
    // 是否支持多选文件
    multiple: {
      type: Boolean,
      default: true
    },
    // 上传文件字段名 等同于file_post_name
    name: {
      type: String,
      default: 'file'
    },
    // 上传文件类型限制 等同于file_types
    accept: {
      type: String
    },
    // 上传文件大小限制 等同于file_size_limit
    size: {
      type: String
    },
    // 是否显示上传文件列表
    showFileList: {
      type: Boolean,
      default: true
    },
    // 上传按钮点击 等同于file_dialog_start_handler
    onClick: {
      type: Function,
      default: noop
    },
    // 文件状态改变钩子 等同于file_queued_handler
    onChange: {
      type: Function,
      default: noop
    },
    // 文件窗口关闭钩子 等同于file_dialog_complete_handler
    onDialogComplete: {
      type: Function,
      default: noop
    },
    // 文件添加队列错误钩子 等同于file_queue_error_handler
    onQueueError: {
      type: Function,
      default: noop
    },
    // 上传前钩子 等同于upload_start_handler
    onBefore: {
      type: Function
    },
    // 上传时钩子 等同于upload_progress_handler
    onProgress: {
      type: Function,
      default: noop
    },
    // 上传成功时钩子 等同于upload_success_handler
    onSuccess: {
      type: Function,
      default: noop
    },
    // 上传失败时钩子 等同于uploadError
    onError: {
      type: Function,
      default: noop
    },
    // 删除文件前钩子
    // onBeforeRemove: {
    //   type: Function,
    //   default: noop
    // },
    // 文件列表删除文件钩子
    onRemove: {
      type: Function,
      default: noop
    },
    // 点击文件列表钩子
    // onPreview: {
    //   type: Function
    // },
    // 文件取消钩子
    onCancel: {
      type: Function,
      default: noop
    },
    // 文件全部取消
    onCancelAll: {
      type: Function,
      default: noop
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 文件最大上传个数
    queueLimit: {
      type: Number
    },
    uploadLimit: {
      type: Number
    },
    // 是否自动上传
    autoUpload: {
      type: Boolean,
      default: false
    },
    // 处理上传的Ajax方法
    httpRequest: {
      type: Function,
      default: ajax
    },
    // 上传的文件列表
    fileList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      queue_cancelled_flag: false,
      upFiles: [],
      tempIndex: 1,
      reqs: {},
      len: 0
      // flag: false,
      // uploadList: {}
    }
  },
  watch: {
    fileList: {
      immediate: true,
      handler (fileList) {
      }
    }
  },
  computed: {

  },
  methods: {
    /**
     * 点击上传按钮触发 step1
     * @description disabled为false时可用
     */
    handleClick () {
      if (!this.disabled) {
        this.onClick() // fileDialogStart()
        this.$refs.input.value = null
        this.$refs.input.click()
      }
    },
    /**
     * 选取文件后触发 step2
     * @param event
     */
    handleChange (e) {
      const files = e.target.files
      if (!files) return
      this.uploadFiles(files)
    },
    /**
     * 包装文件对象并上传 step3
     * @param files
     */
    uploadFiles (files) {
      let fs = Array.prototype.slice.call(files)
      if (!this.multiple) fs = fs.slice(0, 1)
      if (fs.length === 0) return
      if (location.href.indexOf('/link/view') <= -1 && localStorage.approveExist === 'true') {
        UploadList.prototype.listMaskShow() // 审批遮罩层
      } else {
        UploadList.prototype.listMaskHide() // 审批遮罩层隐藏
      }
      UploadList.prototype.show() // 打开列表
      UploadList.prototype.listFirst()
      if (fs.length > this.queueLimit) {
        UploadList.prototype.warn('queue_limit_warn', this.queueLimit)
        // UploadList.prototype.warn('您一次最多只能添加' + this.queueLimit + '个文件！')
        return
      } else {
        UploadList.prototype.clearWarn()
      }

      for (let i = 0; i < fs.length; i++) {
        let file = this.handleStart(fs[i]) // 文件校验包装
        // autoUpload为true且上传文件必须是QUEUED等状态
        if (this.autoUpload && file.filestatus === VUEUpLoad.FILE_STATUS.QUEUED) {
          if (this.serial) {
            if (!this._hasStatus(VUEUpLoad.FILE_STATUS.IN_PROGRESS) && i === 0) {
              this.upload(fs[0]) // 队列上传
            }
          } else {
            this.upload(fs[i]) // 并发上传
          }
        }
      }
      // fs.forEach(f => {
      //   let file = this.handleStart(f) // 文件校验包装
      //   // autoUpload为true且上传文件必须是QUEUED等状态
      //   if (this.autoUpload && file.filestatus === VUEUpLoad.FILE_STATUS.QUEUED) {
      //     this.upload(f) // 上传
      //   }
      // })
      // 一次选择文件完成后触发 fs可能是N个文件
      this.onDialogComplete(fs, this.upFiles) // fileDialogComplete
    },
    /**
     * 包装文件并校验 step3-1
     * @param f
     */
    handleStart (f) {
      f.id = 'SWFUpload_LenvoBox_' + new Date().getFullYear() + '_' + this.tempIndex++
      f.index = this.upFiles.length + 1
      let file = {
        id: f.id,
        index: f.index,
        name: f.name,
        type: f.name.substr(f.name.lastIndexOf('.')),
        creationdate: new Date(),
        modificationdate: new Date(),
        filestatus: VUEUpLoad.FILE_STATUS.QUEUED,
        size: f.size,
        percentage: 0,
        time: '00:00:00',
        raw: f
      }
      try {
        file.url = URL.createObjectURL(f)
      } catch (e) {
        console.error(e)
        return
      }
      UploadList.prototype.add(file) // 列表添加数据
      let num = 0
      for (let o of this.upFiles) {
        if (o.filestatus === VUEUpLoad.FILE_STATUS.QUEUED || o.filestatus === VUEUpLoad.FILE_STATUS.IN_PROGRESS) {
          num++
        }
      }
      let val = new Validate()
      val.add(f, [
        {
          strategy: 'QUEUE_LIMIT_EXCEEDED:' + this.queueLimit + ':' + num
        },
        {
          strategy: 'ZERO_BYTE_FILE'
        },
        {
          strategy: 'FILE_EXCEEDS_SIZE_LIMIT:' + this.size
        },
        {
          strategy: 'INVALID_FILETYPE:' + this.accept
        }
      ])
      let err = val.check()
      if (err) {
        let message = this.onQueueError(err, f)
        file.filestatus = VUEUpLoad.FILE_STATUS.ERROR
        UploadList.prototype.error(message, f)
      } else {
        this.upFiles.push(file)
        this.onChange(file, this.upFiles)
      }
      return file
    },
    /**
     * 包装文件并校验 step3-2
     * @param f
     */
    upload (f) {
      this.queue_cancelled_flag = false

      this.$refs.input.value = null
      if (!this.onBefore) {
        return this.post(f)
      }

      const before = this.onBefore(this.getFile(f.id))
      if (before && before.then) {
        before.then(processedFile => {
          // if (Object.prototype.toString().call(processedFile) === '[object File]') {
          //   this.post(processedFile)
          // } else {
          //   this.post(f)
          // }
          if (processedFile) f.action = processedFile // handleUploadBefore会返回上传的最新URL
          this.post(f)
        }, (message) => {
          this.handleRemove(f, true)
          UploadList.prototype.error(message, f)
          if (this.serial && !this.queue_cancelled_flag) {
            let next = f.index + 1 // 下一个文件的索引
            this._nextUpload(next)
          }
        })
      } else if (before !== false) {
        this.post(f)
      } else {
        this.handleRemove(f, true)
      }
    },
    /**
     * 上传 step4
     * @param f
     */
    post (f) {
      console.log('post********************' + f.id)
      const { id } = f
      const options = {
        headers: this.headers,
        file: f,
        data: this.data,
        filename: this.name,
        action: f.action ? f.action : this.action, // 如果f中有action属性则使用f.action
        onProgress: e => {
          this.handleProgress(e, f)
        },
        onSuccess: res => {
          this.getFile(f.id).filestatus = VUEUpLoad.FILE_STATUS.COMPLETE
          this.onSuccess(res, f)
          delete this.reqs[id]
          UploadList.prototype.success(f, this.upFiles) // 上传成功改变列表
        },
        /* eslint-disable */
        onError: err => {
          this.getFile(f.id).filestatus = VUEUpLoad.FILE_STATUS.ERROR
          let message = this.onError(err, f)
          delete this.reqs[id]
          UploadList.prototype.error(message, f) //
        },
        onComplete: (res, xhr) => {
          if (this.serial && !this.queue_cancelled_flag) {
            let next = res.index + 1 // 下一个文件的索引
            this._nextUpload(next)
          }
        }
      }

      if (this.getFile(f.id).filestatus !== VUEUpLoad.FILE_STATUS.QUEUED) {
          console.log('warn!!!!!!!' + f.id + ' status change ' + this.getFile(f.id).filestatus)
          return
      }
      const req = this.httpRequest(options)
      this.reqs[id] = req

      if (req && req.then) {
        req.then(options.onSuccess, options.onError)
      }
    },
    /**
     * 处理上传过程 step4-1
     * @param f
     */
    handleProgress (ev, file) {
      let f = this.getFile(file.id)
      this.onProgress(ev, f, this.upFiles)
      f.filestatus = VUEUpLoad.FILE_STATUS.IN_PROGRESS
      f.percentage = ev.percent || 0
      f.time = ev.time || '00:00:00'
      UploadList.prototype.progress(f) // 上传改变文件显示
    },
    /**
     * 过去upFiles中对应的文件
     * @param f
     */
    getFile (f) {
      let fileList = this.upFiles
      let target
      fileList.every(item => {
        target = f == item.id ? item : null
        return !target
      })
      return target
    },
    handleRemove (file, raw) {
      if (raw) {
        file = this.getFile(file.id)
      }
      this.abort(file)
      let fileList = this.upFiles
      fileList.splice(fileList.indexOf(file), 1)
      this.onRemove(file, fileList)
    },
    /**
     * 取消xmlhttprequest请求 step4-2
     * @param file
     */
    abort (file) {
      const { reqs } = this
      if (file) {
        let id = file
        if (file.id) id = file.id
        if (reqs[id]) {
          reqs[id].abort()
        }
      } else {
        Object.keys(reqs).forEach((id) => {
          if (reqs[id]) reqs[id].abort()
          delete reqs[id]
        })
      }
    },
    /**
     * 检查上传状态
     * @description 用于上传列表关闭
     */
    checkUploadStatus () {
      for (let item of this.upFiles) {
        if (item.filestatus === VUEUpLoad.FILE_STATUS.IN_PROGRESS) {
          if (window.confirm('确认取消所有未完成的任务?')) {
            const { reqs } = this
            Object.keys(reqs).forEach((id) => {
              if (reqs[id]) reqs[id].abort()
              delete reqs[id]
            })
            this.upFiles = []
            return true
          }
          return false
        }
      }
      this.upFiles = []
      return true
    },
    /**
     * 取消上传
     * @param fid 取消上传id
     * @description 该方法同步SWF的cancelUpload，不同的是不会触发uploadError
     */
    cancelUpload (fid) {
      let file = this.getFile(fid)
      const { reqs } = this
      for (let item of this.upFiles) {
        if (item.id === fid) {
          this.queue_cancelled_flag = false
          if (reqs[item.id]) {
            reqs[item.id].abort()
          }
          delete reqs[item.id]
          item.filestatus = VUEUpLoad.FILE_STATUS.CANCELLED
          item.time = '00:00:00'
          item.percentage = 100
          this.onCancel(file)
          return
        }
      }
      // 如果fid不存在 则取消全部uploading状态文件的上传
      if (file) {
        // this.queue_cancelled_flag = false
        // let id = file.id
        // // if (file.id) id = file.id
        // // 下面的代码移动到这是因为，队列模式中取消上传时当前文件可能有没有req
        // file.filestatus = VUEUpLoad.FILE_STATUS.CANCELLED
        // file.time = '00:00:00'
        // file.percentage = 100
        // this.onCancel(file)
        // if (reqs[id]) {
        //   reqs[id].abort()
        //   // file.filestatus = VUEUpLoad.FILE_STATUS.CANCELLED
        //   // file.time = '00:00:00'
        //   // file.percentage = 100
        //   // this.onCancel(file)
        // }
      } else {
        this.queue_cancelled_flag = true
        for (let item of this.upFiles) {
          if (item.filestatus === VUEUpLoad.FILE_STATUS.IN_PROGRESS || item.filestatus === VUEUpLoad.FILE_STATUS.QUEUED) {
            if (reqs[item.id]) {
              reqs[item.id].abort()
            }
            delete reqs[item.id]
            item.filestatus = VUEUpLoad.FILE_STATUS.CANCELLED
            item.time = '00:00:00'
            item.percentage = 100
          }
        }
        this.onCancelAll(this.upFiles)
      }
    },
    /**
     * 手动
     * @description 如果autoUpload为false 则组件进行到handleStart时就会停止，file_dialog_complete_handler中可以
     * 调用this.startUpload手动上传列表中未上传状态的文件
     */
    startUpload () {
      // this.upFiles.forEach(f => {
      //   if (f.filestatus === VUEUpLoad.FILE_STATUS.QUEUED) {
      //     this.upload(f.raw)
      //   }
      // })
      this.queue_cancelled_flag = false
          if (this.len === 0) {
        console.log('len is 0')
        this.len = this.upFiles.length
      }
      console.log(this.upFiles.length)
      console.log(this.len)
//      if (this.upFiles.length > this.len) {
//        console.log('click upload button twice do not execute')
//        return
//      }
      console.log('click upload button first time')
      for (let i = 0; i < this.upFiles.length; i++) {
        if (this.upFiles[i].filestatus === VUEUpLoad.FILE_STATUS.QUEUED) { // 待上传文件的状态必须是队列状态
          if (this.serial) { // 队列模式
            if (!this._hasStatus(VUEUpLoad.FILE_STATUS.IN_PROGRESS)) { // 没有正在上传的文件
              this.upload(this.upFiles[i].raw) // 上传
              break
            }
          } else {
            this.upload(this.upFiles[i].raw) // 并发上传
          }
        }
      }
    },
    /**
     * 创建Error
     * @param code
     * @param message
     * @returns {Error}
     * @private
     */
    _createError (code, message) {
      let err = new Error()
      err.code = code
      err.message = message
      return err
    },
    /**
     * 上传下一个文件
     * @param index
     * @private
     */
    _nextUpload (index) {
      let nextFile = this._getFileByIndex(index)
      if (nextFile) {
        if (nextFile.filestatus === VUEUpLoad.FILE_STATUS.QUEUED) { // 下一个上传文件必须是队列状态
          this.upload(nextFile.raw)
        } else {
          this._nextUpload(nextFile.index + 1) // warn！递归
        }
      } else {
          console.log('all upload is complete the len 0')
          this.len = 0
          UploadList.prototype.listNormal()
      }
    },
    /**
     * 按索引检索文件
     * @param index
     * @returns {target}
     * @private
     */
    _getFileByIndex (index) {
      let target
      this.upFiles.every(item => {
        target = index == item.index ? item : null
        return !target
      })
      return target
    },
    /**
     * 检测列表中是否有某个状态
     * @param status
     * @returns {boolean}
     * @private
     */
    _hasStatus (status) {
      let res = false
      for (let i of this.upFiles) {
        if (i.filestatus === status) {
          return true
        }
      }
      return res
    }
  }
}
</script>

<style>
  .upload-button {
    background-color: #157BF8;
    border: 1px solid #0E6CDF;
    display: inline-block;
    height: 30px;
    width: 95px;
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
  }
  .upload-disabled {
    cursor: not-allowed;
    background-color: #95c5ff;
    border: 1px solid #95c5ff;
  }
  .upload-input {
    display: none;
  }
  .uploadList-enter-active, .uploadList-leave-active {
    transition: all 1.5s;
  }
  .uploadList-enter, .uploadList-leave-to {
    opacity: 0;
  }
  .uploadList-enter {
    transform: translateY(+100%);
  }
  .uploadList-leave-active {
    transform: translateY(100%);
  }
  .lui-mask-upload {
    position: fixed;left: 0;top: 0;width: 100%;height: 100%;
    z-index: -1;
    background-color: #2D2E31;
    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3) 80%);
    background: -moz-radial-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3) 80%);
    background: radial-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3) 80%);
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
    filter: alpha(opacity=50);
    opacity: 0.5;
  }
  .upload-list {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 700px;
    height: 430px;
    background-color: #ffffff;
    border: 1px solid #e8e8e8;
    z-index: 9999;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
  }
  .upload-list-header {
    height: 40px;
    width:  100%;
    background-color: #fff;
    border: 1px solid #fff;
    font-size: 14px;
    color: #323D4C;
    line-height:  40px;
    padding: 0 5px;
    position: relative;
  }
  .upload-list-header-tool {
    position: absolute;
    top: 0;
    right: 24px;
  }
  .upload-list-header-tool i {
    width:14px;
    height: 14px;
    margin-right: 10px;
    cursor: pointer;
  }
  .upload-list-body {
    /* height: 100%; */
     height: 390px;
    border-top: 1px solid #e8e8e8;
    /* border: 1px solid #fff; */
    font-size: 12px;
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
    overflow-y: auto;
  }
  .upload-list-body .upload-list-scroll{
	height: 312px;
	overflow-y: auto;
	overflow-x: hidden;
  }
  .upload-list-body table {
    table-layout: fixed;
  }
  .upload-list-body table>thead {
    color: #323D4C;
    font-weight: 500;
  }
  .upload-list-body table>tbody {
    color: #323D4C;
  }
  .upload-list-body table td {
    padding: 0 10px;
    line-height: 40px;
    overflow: hidden;
    white-space: nowrap;
    /*display: -webkit-box;*/
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    cursor: pointer;
  }
  .upload-list-body table>tbody td:first-child div,
  .upload-list-body table>tbody td:last-child div span {
    overflow: hidden;
    white-space: nowrap;
    /*display: -webkit-box;*/
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    cursor: pointer;
  }

  .pause, .check {
    cursor:pointer;
  }
  .pause i {
    color: #FB5B77;
  }
  .check i {
    color: #7BDF92;
  }
  .upload-list-body-filename {
    color: #409eff;
    cursor: pointer;
  }
  .cancel-all {
    color: #157BF8;
    cursor: pointer;
  }
  .dragenter {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 800;
    background: #666666;
    opacity: 0.5;
    top: 0
  }
  .dragleave {
    width: 1px;
    height: 1px;
    position: static;
    z-index: 0;
    top: 0;
    /*pointer-events: none*/
  }


  /* 不同文件对应的图片 */
  .icon-span {
    float: left;
    width: 24px;
    height:24px;
    margin: 8px 10px 0 0;

  }
  .icon-word{
    background-image: url(../../../assets/iconType/word.png);
  }
  .icon-normal{
    background-image: url(../../../assets/iconType/normal.png);
  }
  .icon-txt{
    background-image: url(../../../assets/iconType/txt.png);
  }
  .icon-png{
    background-image: url(../../../assets/iconType/pic.png);
  }
  .icon-cad{
    background-image: url(../../../assets/iconType/cad.png);
  }
  .icon-max{
    background-image: url(../../../assets/iconType/3d.png);
  }
  .icon-ppt{
    background-image: url(../../../assets/iconType/ppt.png);
  }
  .icon-excel{
    background-image: url(../../../assets/iconType/excel.png);
  }
  .icon-music{
    background-image: url(../../../assets/iconType/music.png);
  }
  .icon-video{
    background-image: url(../../../assets/iconType/video.png);
  }
  .icon-pdf{
    background-image: url(../../../assets/iconType/pdf.png);
  }
  .icon-psd{
    background-image: url(../../../assets/iconType/ps.png);
  }
  .icon-zip{
    background-image: url(../../../assets/iconType/zip.png);
  }
  .icon-apk{
    background-image: url(../../../assets/iconType/apk.png);
  }
  .icon-exe{
    background-image: url(../../../assets/iconType/exe.png);
  }
  .icon-mind{
    background-image: url(../../../assets/iconType/mind.png);
  }
 .icon-html{
    background-image: url(../../../assets/iconType/html.png);
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/upload_vue/upload.vue